import React from 'react';
import { Link } from 'react-router-dom';
import PrivacyPolicy from '../common/PrivacyPolicy';
import ConsentManager from '../common/ConsentManager';
import Terms from '../common/Terms';
import RefundPolicy from '../common/RefundPolicy';
import AccessibilityStatement from '../common/AccessibilityStatement';
import {
  PUBLIC_FOOTER_PLATFORM_LINKS,
  PUBLIC_FOOTER_COMPANY_LINKS,
  PUBLIC_FOOTER_RESOURCES_LINKS,
} from '../../constants/publicMarketingNav';
import styles from './PublicMarketingLayout.module.css';

const PublicSiteFooter: React.FC = () => (
  <footer className={styles.footer}>
    <div className={styles.footerGrid}>
      <div className={styles.footerCol}>
        <h3 className={styles.footerColTitle}>Platform</h3>
        <div className={styles.footerColLinks}>
          {PUBLIC_FOOTER_PLATFORM_LINKS.map(({ to, label }) => (
            <Link key={to + label} to={to}>
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className={styles.footerCol}>
        <h3 className={styles.footerColTitle}>Company</h3>
        <div className={styles.footerColLinks}>
          {PUBLIC_FOOTER_COMPANY_LINKS.map(({ to, label }) => (
            <Link key={to + label} to={to}>
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className={styles.footerCol}>
        <h3 className={styles.footerColTitle}>Resources</h3>
        <div className={styles.footerColLinks}>
          {PUBLIC_FOOTER_RESOURCES_LINKS.map(({ to, label }) => (
            <Link key={to + label} to={to}>
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div className={styles.footerCol}>
        <h3 className={styles.footerColTitle}>Legal</h3>
        <div className={styles.footerLegal}>
          <PrivacyPolicy />
          <ConsentManager />
          <Terms />
          <RefundPolicy />
          <AccessibilityStatement />
        </div>
      </div>
    </div>
    <p className={styles.footerCopyright}>&copy; {new Date().getFullYear()} TRANZIT. All rights reserved.</p>
  </footer>
);

export default PublicSiteFooter;
